import React, { useContext } from 'react'
import { navigate } from '@reach/router'
import UserContext, { Roles } from '../../UserContext'
import Cookies from 'js-cookie'
import EmailLinkTracker from '../EmailLinkTracker'
import { getRootDomain, isHAPLoginIntent } from '../../utilities'

const nav = (path: string) => setTimeout(() => void navigate(path), 100)

type PrivateRouteProps = {
    path: string
    default?: boolean
    as: React.ElementType
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ as: Comp, ...restOfTheProps }) => {
    const { token, user } = useContext(UserContext)

    if (!Cookies.get('cs_id_token') && window.location.pathname.toLowerCase() !== '/logout') {
        // eslint-disable-next-line no-console
        console.log('Forced to login route', !!token, !!Cookies.get('cs_id_token'), Cookies.get('cs_id_token') ? `${Cookies.get('cs_id_token')?.substring(0, 10) as string} ...` : 'no token')
        sessionStorage.setItem('path-callback', window.location.pathname + window.location.search)

        const useLoginMatch = /(?:\?|&)UseLogin=([^&]*)/.exec(window.location.search)
        const hapCookie = Cookies.get('cs_hap')
        const isHAPJourney = hapCookie === 'true' || isHAPLoginIntent(useLoginMatch?.[1])
        if (isHAPJourney) {
            // Flag that the login page should show the MI HAP Portal button.
            // - sameSite: 'none' + secure: true so the cookie survives cross-domain
            //   redirects from Provider Portal back to Provider Sourcing.
            // - 10-minute TTL so a stale flag from an abandoned login doesn't affect
            //   a later unrelated link click.
            // - Domain scoped to the root (e.g. caresource.com) so Provider Portal
            //   on a sibling subdomain can also read this cookie.
            const tenMinutes = new Date(Date.now() + 10 * 60 * 1000)
            const rootDomain = getRootDomain()
            Cookies.set('cs_hap_pending', 'true', {
                sameSite: 'none',
                secure: true,
                expires: tenMinutes,
                ...(rootDomain ? { domain: rootDomain } : {}),
            })
        }

        if (hapCookie !== undefined) {
            Cookies.remove('cs_hap')
        }
        nav('login')
        return null
    }

    const callback = sessionStorage.getItem('path-callback')

    if (callback) {
        sessionStorage.removeItem('path-callback')
        nav(callback)
        return null
    }

    // If the user object is populated make sure they have at least one non-impersonator role
    if(user.userID
        && (user.roles.length === 0 || (user.roles.length === 1 && user.roles[0] === Roles.Impersonator ))) {
        // eslint-disable-next-line no-console
        console.log('Roles invalid', user.roles)
        nav('login')
        return null
    }

    return token ? <>
        <EmailLinkTracker />
        <Comp {...restOfTheProps} />
    </> : null
}

export default PrivateRoute
